import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let routes = [
  //饿了么外卖
  {
    path: '/ele/shopList',
    name: 'shopList',
    component: () => import('./views/ele/ShopList/ShopList.vue'),
    meta: {
      keepAlive: true
    },
    backRouteName: 'ievent'
  }, {
    path: '/ele/shopDetail',
    name: 'shopDetail',
    component: () => import('./views/ele/ShopDetail/ShopDetail.vue'),
    meta: {
      keepAlive: true
    }
  }, {
    path: '/ele/oderSubmit',
    name: 'orderSubmit',
    component: () => import('./views/ele/OrderSubmit/OrderSubmit.vue'),
    meta: {
      keepAlive: true
    }
  }, {
    path: '/ele/address',
    name: 'address',
    component: () => import('./views/ele/Address/Address.vue'),
    meta: {
      keepAlive: false
    }
  }, {
    path: '/ele/addAddress',
    name: 'addAddress',
    component: () => import('./views/ele/AddAddress/AddAddress.vue'),
    meta: {
      keepAlive: false
    }
  }, {
    path: '/ele/addressMap',
    name: 'addressMap',
    component: () => import('./views/ele/AddressMap/AddressMap.vue'),
    meta: {
      keepAlive: false
    }
  }, {
    path: '/ele/shopSearch',
    name: 'shopSearch',
    component: () => import('./views/ele/ShopSearch/ShopSearch.vue'),
    meta: {
      keepAlive: false
    }
  }, {
    path: '/ele/success',
    name: 'success',
    component: () => import('./views/ele/checkoutSuccess.vue'),
    meta: {
      keepAlive: false
    }
  }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})
router.afterEach((to, from) => {
  let route = {}
  routes.map((item) => {
    if(item.name == to.name) {
      route = item;
      return;
    }
  })
  nativeJsBridge.setRouter(router);
  const backRouteName  = route.backRouteName ? route.backRouteName : 'root'
  nativeJsBridge.setbackRouteName(backRouteName)

})
export default router
